var _rect, _text, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallbackImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 400,
    viewBox: "0 0 247 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 12,
    fill: "#f5f5f5",
    stroke: "#e0e0e0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 24,
    fill: "url(#gradient)",
    textAnchor: "middle",
    alignmentBaseline: "middle"
  }, "\n    ICH\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8b572a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4a90e2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackImg);
export default __webpack_public_path__ + "static/media/fallback_img.37047c6258e442d0c550a3e9456f8041.svg";
export { ForwardRef as ReactComponent };